export const PREDEFINED = 'PREDEFINED';
export const RANGE = 'RANGE';

export const NOTIFICATION_MESSAGE =
  'To use this control feature, you must have tags that are mapped to controller';
